import { Grid, Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import ImageContainer from 'artkive/components/ImageContainer'
import theme from 'artkive/utils/theme'

import KeepsakeSection from './KeepsakeSection'

const TITLE_MAX_WIDTH = 345

export const Section = withStyles({
  root: {
    paddingBottom: 96,
    backgroundColor: theme.colors.white.main,
  },
})(KeepsakeSection)

export const Features = styled('div')({
  position: 'relative',
})

export const FeatureGrid = styled(Grid)({
  position: 'relative',
  zIndex: 0,
})

const featureStyles = ({ theme: { breakpoints }, last }) => ({
  textAlign: 'center',
  [breakpoints.down('sm')]: {
    marginBottom: last ? 0 : 48,
  },
})
// Keeps last off the DOM element.
featureStyles.filterProps = ['last']

export const Feature = styled('div')(featureStyles)

export const PhotoWrapper = styled('div')({
  marginBottom: 24,
})

export const Photo = styled(ImageContainer)({
  overflow: 'hidden',
  borderRadius: 8,
})

const titleStyles = ({ theme: { breakpoints }, titleWidth, mobileTitleWidth }) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  [breakpoints.down('sm')]: {
    maxWidth: mobileTitleWidth ?? TITLE_MAX_WIDTH,
  },
  [breakpoints.up('md')]: {
    maxWidth: titleWidth ?? TITLE_MAX_WIDTH,
    minHeight: 56,
  },
})
// Keeps the widths off the DOM element.
titleStyles.filterProps = ['titleWidth', 'mobileTitleWidth']

export const Title = styled(Typography)(titleStyles)

export const Body = styled('div')(({ theme: { breakpoints } }) => ({
  marginTop: 24,
  textAlign: 'center',
  [breakpoints.down('sm')]: {
    textAlign: 'left',
  },
  [breakpoints.up('md')]: {
    maxWidth: 270,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}))
